<template>
  <div>
    <svg
      :style="{
        width: width || '40px',
        height: height || '40px',
      }"
      width="800px"
      height="800px"
      viewBox="-9.5 0 51 51"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <title>012-Flag</title>
      <desc>Created with Sketch.</desc>
      <defs></defs>
      <g
        id="Page-1"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g id="Artboard" transform="translate(-749.000000, -737.000000)">
          <g id="012-Flag" transform="translate(749.000000, 737.000000)">
            <path
              d="M7.6778,44.4376 C7.6778,44.4376 6.6218,39.2346 5.8658,39.4376 C5.1088,39.6406 4.4898,44.4996 4.4898,44.4996 C4.4898,44.4996 1.5168,42.1906 0.8658,42.3746 C0.2138,42.5596 1.9738,50.2326 6.0188,49.6736 C10.0648,49.1146 11.4138,42.6106 10.7408,42.2186 C10.0658,41.8266 7.6778,44.4376 7.6778,44.4376"
              id="Fill-1392"
              fill="#497B41"
            ></path>
            <path
              d="M8.7084,48.5286 C8.7084,47.8806 7.5474,47.3546 6.1154,47.3546 C4.6834,47.3546 3.5224,47.8806 3.5224,48.5286 C3.5224,49.1766 4.6834,49.7026 6.1154,49.7026 C7.5474,49.7026 8.7084,49.1766 8.7084,48.5286"
              id="Fill-1394"
              fill="#B98971"
            ></path>
            <polygon
              id="Fill-1396"
              fill="#C27D78"
              points="3.34 48.529 8.708 48.529 8.708 1.686 3.34 1.686"
            ></polygon>
            <path
              d="M8.7084,4.4632 C8.7084,3.8152 7.5064,3.2892 6.0244,3.2892 C4.5424,3.2892 3.3404,3.8152 3.3404,4.4632 C3.3404,5.1112 4.5424,5.6372 6.0244,5.6372 C7.5064,5.6372 8.7084,5.1112 8.7084,4.4632"
              id="Fill-1398"
              fill="#EDF1F1"
            ></path>
            <path
              d="M6.0251,21.2249 C4.5431,21.2249 3.3411,20.6989 3.3411,20.0509 L3.3411,22.8279 C3.3411,23.4769 4.5431,24.0019 6.0251,24.0019 C7.5071,24.0019 8.7091,23.4769 8.7091,22.8279 L8.7091,20.0509 C8.7091,20.6989 7.5071,21.2249 6.0251,21.2249"
              id="Fill-1399"
              fill="#EDF1F1"
            ></path>
            <polygon
              id="Fill-1400"
              fill="#EDF1F1"
              points="3.34 4.463 8.708 4.463 8.708 1.686 3.34 1.686"
            ></polygon>
            <path
              d="M8.7084,1.6861 C8.7084,1.0381 7.5064,0.5121 6.0244,0.5121 C4.5424,0.5121 3.3404,1.0381 3.3404,1.6861 C3.3404,2.3341 4.5424,2.8601 6.0244,2.8601 C7.5064,2.8601 8.7084,2.3341 8.7084,1.6861"
              id="Fill-1401"
              fill="#C27D78"
            ></path>
            <path
              d="M9.015,2.1234 L7.015,3.1234 L28.851,15.6654 C28.851,15.6654 31.992,15.1884 31.718,14.2574 C30.78,11.0694 9.015,2.1234 9.015,2.1234"
              id="Fill-1402"
              fill="#F7BF6D"
            ></path>
            <path
              d="M31.7282,14.3202 L28.7712,15.6652 L24.0162,23.2012 L28.5062,36.4392 C28.5062,36.4392 31.6332,35.6372 31.6382,34.6322 C31.6602,30.1952 26.7882,23.4292 26.7882,23.4292 C26.7882,23.4292 31.7282,17.9642 31.7282,14.3202"
              id="Fill-1403"
              fill="#FBDF89"
            ></path>
            <path
              d="M7.0148,3.1235 L7.0148,24.9075 C7.0148,24.9075 26.9478,37.8275 28.7708,36.3385 C30.5938,34.8495 24.0158,23.2005 24.0158,23.2005 C24.0158,23.2005 29.1948,17.9535 28.7708,15.5535 C28.3468,13.1545 7.0148,3.1235 7.0148,3.1235"
              id="Fill-1404"
              fill="#F1A969"
            ></path>
            <path
              d="M5.5223,50.9244 C4.3553,50.9244 7.6943,44.8954 8.2573,44.5674 C9.2573,43.9834 10.2233,47.7114 8.9063,49.1694 C7.5893,50.6274 6.6893,50.9244 5.5223,50.9244"
              id="Fill-1405"
              fill="#72BC76"
            ></path>
            <path
              d="M1.0215,46.4571 C1.3075,46.0281 7.9905,49.9461 7.0265,50.5281 C6.2915,50.9731 5.4735,51.0471 4.5025,50.7811 C4.0165,50.6471 3.1985,49.9851 2.8635,49.5961 C1.9695,48.5611 0.7925,46.8011 1.0215,46.4571"
              id="Fill-1406"
              fill="#72BC76"
            ></path>
            <path
              d="M14.458,16.2109 C14.458,16.2109 16.179,12.2759 17.003,12.6759 C17.827,13.0749 18.187,17.2899 18.187,17.2899 C18.187,17.2899 21.609,18.5749 21.759,19.3349 C21.909,20.0949 18.562,20.9329 18.562,20.9329 C18.562,20.9329 19.404,25.6789 18.605,25.6789 C17.805,25.6789 15.5,21.6079 15.5,21.6079 C15.5,21.6079 12.256,23.7069 11.987,22.9899 C11.719,22.2729 13.317,19.1849 13.317,19.1849 C13.317,19.1849 10.302,16.8639 10.901,15.7879 C11.161,15.3229 14.458,16.2109 14.458,16.2109"
              id="Fill-1407"
              fill="#FBDF89"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: "FlagIcon",
  props: ["width", "height"],
};
</script>

<style>
</style>